import React from 'react';

export const useShowBlock = (guid, state, setIsOpen, isDisabled = false) => {
    const isShow = state[guid];

    const onShow = () => {
        if (!isDisabled) {
            const newState = { ...state, [guid]: !state[guid] };
            setIsOpen(newState);
        }
    };

    return {
        isShow,
        onShow,
    };
};
